import { AsyncSeriesWaterfallHook, AsyncSeriesHook, SyncBailHook } from 'tapable';

(function () {
  angular.module('7Shop.Common')
    .service('HooksManager', HooksManager);

  /**
     * @class HooksManager
     * @memberOf module:"7Shop.Common"
     */
  function HooksManager($q, $log) {
    this.hooks = {
      BetslipBeforeBetAdd: new AsyncSeriesWaterfallHook(['productId']),
      BeforeBetslipPayin: new AsyncSeriesWaterfallHook(['bets', 'stake', 'updatedBets', 'betslipId']),
      'DirectTransferController.BeforeSearchPlayer': new AsyncSeriesHook(),
      'DirectTransferController.BeforeSubmitDeposit': new AsyncSeriesHook(),
      'WithdrawalProcessing.BeforeGetWithdrawalInfo': new AsyncSeriesHook(),
      BeforeVoucherCreate: new AsyncSeriesWaterfallHook(['voucher']),
      BeforeVoucherCancel: new AsyncSeriesWaterfallHook(['voucher']),
      BeforeVoucherPayout: new AsyncSeriesWaterfallHook(['voucher']),
      BeforeTicketPayin: new AsyncSeriesWaterfallHook(['params', 'product']),
      BeforeTicketCancel: new AsyncSeriesWaterfallHook(['ticket']),
      BeforeTicketPayout: new AsyncSeriesWaterfallHook(['ticket']),
      'RomTax:GetPlayerData': new AsyncSeriesWaterfallHook(['cnp']),
      'RomTax:AddFormData': new AsyncSeriesWaterfallHook(['params']),
      'RomTax:BeforeCustomerCardPayout': new AsyncSeriesWaterfallHook(['cnp']),
      AfterPayoutTicket: new AsyncSeriesWaterfallHook(['ticketId']),
      BeforeTicketPreview: new AsyncSeriesWaterfallHook(['isTicketWon']),
      BeforeLogout: new AsyncSeriesWaterfallHook(['logout']),
      'CustomerCards.CardDetailsFetched': new SyncBailHook(['cardData']),
      BeforePrint: new AsyncSeriesHook(['printData'])
    };

    this.run = function (hookName, params) {
      if (!this.hooks[hookName]) {
        $log.error(`[7Shop.Common] Hook ${hookName} doesn't exist.`, {
          code: 'S_COMMON_HOOK_NO_EXIST',
          details: {
            hookName
          }
        });
        return $q.reject({
          message: `[7Shop.Common] Hook ${hookName} doesn't exist.`,
          code: 'S_HOOK_NOT_FOUND'
        });
      }

      return this.hooks[hookName].promise(params);
    };

    this.getHook = function (hookName) {
      return this.hooks[hookName];
    };
  }
})();
